import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const iconButtonBaseFn = /* @__PURE__ */ createRecipe('iconButtonBase', {
  "size": "md"
}, [])

const iconButtonBaseVariantMap = {
  "size": [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
  ]
}

const iconButtonBaseVariantKeys = Object.keys(iconButtonBaseVariantMap)

export const iconButtonBase = /* @__PURE__ */ Object.assign(memo(iconButtonBaseFn.recipeFn), {
  __recipe__: true,
  __name__: 'iconButtonBase',
  __getCompoundVariantCss__: iconButtonBaseFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: iconButtonBaseVariantKeys,
  variantMap: iconButtonBaseVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, iconButtonBaseVariantKeys)
  },
  getVariantProps: iconButtonBaseFn.getVariantProps,
})